const fallbackCopy = (text) => {
    if (typeof document === 'undefined') return false;

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    let copied = false;
    try {
        copied = document.execCommand('copy');
    } finally {
        document.body.removeChild(textarea);
    }

    return copied;
};

export const copyText = async (text) => {
    const clipboard = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;

    if (clipboard?.writeText) {
        await clipboard.writeText(text);
        return;
    }

    if (fallbackCopy(text)) return;

    throw new Error('Clipboard copy failed. Your browser may have denied clipboard access. Try using Ctrl+C instead.');
};
